"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.getYearlyDefaultRetentionFieldsSettings = void 0;
const constants_1 = require("../constants");
require("../types");
const getYearlyDefaultRetentionFieldsSettings = (value) => {
    return {
        fieldCountMin: value.fieldCountMin || constants_1.RETENTION_COUNT_MIN,
        fieldCountMax: value.fieldCountMax || constants_1.RETENTION_COUNT_MAX_YEARLY,
        fieldCountInitialValue: value.fieldCountInitialValue || constants_1.RETENTION_COUNT_MIN,
    };
};
exports.getYearlyDefaultRetentionFieldsSettings = getYearlyDefaultRetentionFieldsSettings;
//# sourceMappingURL=getYearlyDefaultRetentionFieldsSettings.js.map